import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { ModalManagerProvider } from './context/ModalManagerContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ModalManagerProvider>
        <App />
      </ModalManagerProvider>
    </AuthProvider>
  </React.StrictMode>
);

